export const KEYWORDS_LIST_KEY = 'KEYWORDS_LIST';
export const KEYWORDS_ONE_KEY = 'KEYWORDS_ONE_KEY';
